// Interface for Initialize Interview Request

export interface ScoreReport {
  improvementArea: string;
  question: string;
  score: string;
  strength: string;
  userAnswer: string;
}

export interface InitializeInterviewRequest {
  JobDescription: string;
  MaxQuestions: string;
  BotName: string;
  Title: string;
  conversationMode?: ConversationMode;
}

export interface BaseResponse {
  response: string | null;
  isProvidingScore: boolean;
  scoreReport: ScoreReport[] | null;
  overallScore: number | null;
  overallReport: any | null;
  jobTitle: string | null;
  isUserResponseOutOfScope: boolean | null;
  seniorityLevel: string | null;
  threadId: string | null;
  success: boolean;
  errorMessage: string | null;
  dateTime: string;
  creditAmount: number | null;
  status: string;
  isInterviewComplete?: boolean;
}

// Interface for Initialize Interview Response (Success & Error cases combined)
export type InitializeInterviewResponse = BaseResponse & { botName: string };

// Interface for Generate Speech Request
export interface GenerateSpeechRequest {
  TextMessage: string;
  Voice: string;
}

// Interface for Reply Request
export interface ReplyRequest {
  ThreadId: string;
  CandidateAnswer: string;
}

// Interface for Reply Response (same structure as BaseResponse)
export type ReplyResponse = BaseResponse;

export enum ConversationMode {
  VIDEO = "video",
  CHAT = "chat",
  VOICE = "voice",
}

export interface InterviewSetup {
  isAuto: boolean;
  conversationMode: ConversationMode | null;
  started: boolean;
  paused: boolean;
  completed: boolean;
}

export enum InterviewStatus {
  NOT_STARTED_YET = "Not Started Yet",
  INTERVIEW_RESUMED = "Interview Resumed",
  INTERVIEW_STARTED = "Interview Started",
  INTERVIEW_STOPPED = "Interview Stopped",
  INTERVIEW_COMPLETED = "Interview Completed",
}

export enum InterViewCurrentTask {
  NO_TASK_YET = "No Task Yet",
  BOT_SPEAKING = "Bot Speaking",
  BOT_TYPING = "Bot Typing",
  YOU_SPEAKING = "You Speaking",
  YOU_TYPING = "You Typing",
  INTERVIEW_STOPPED = "Interview Stopped",
  PROCESSING_ANSWER = "Processing Your Answer",
  RECORDING_STOPPED = "Recording Stopped",
  WAITING_YOU_FOR_REPLY = "Waiting your reply, press record to start answering",
  TRYING_TO_STOP_INTERVIEW = "Trying to stop interview",
  TRYING_TO_RESUME_INTERVIEW = "Trying to resume interview",
  INTERVIEW_COMPLETTED = "Interview Completted",
}

export interface Interviewer {
  id: number;
  name: string;
  image: string;
  voiceName: string;
  faceId: string;
}

export interface InterviewInitState {
  sentData: InitializeInterviewRequest;
  selectedInterviweer: Interviewer;
  setup: InterviewSetup;
  initialResponse: InitializeInterviewResponse | null;
}
export interface Interview {
  finalTranscript: string;
  isChatInputsEnabled: boolean;
  isEnabledSubmitButton: boolean;
  showProcessing: boolean;
  setUp?: InterviewSetup;
}

// src/types/interviewTypes.ts

export interface InterviewJobDetail {
  jobTitle: string | null;
  jobRole: string | null;
  seniorityLevel: string | null;
  jobGrade: string | null;
  requiredSkills: string[];
  optionalSkills: string[];
  yearsofExperience: string | null;
  educationalBackgrounds: string[] | null;
  certificationsRequired: string[] | null;
  certificationsOptional: string[] | null;
  companyName: string | null;
  salary: string | null;
  additionalInformation: string | null;
  languages: string[];
}

export interface Interview {
  id: number;
  status: string; // e.g. "InterviewSessionStarted" or "InterviewCompeleted"
  overallScore: string | null;
  overallReport: string | null;
  jobDetail: InterviewJobDetail;
  createdDate: string;
  lastUpdatedDate: string;
}

export interface InterviewsResponse {
  totalCount: number;
  interviews: Interview[];
}

export interface InterviewScore {
  question: string;
  userAnswer: string;
  score: string;
  strength: string;
  improvementArea: string;
  id: number;
  createdDate: string;
  lastUpdatedDate: string;
}
